import languageUtils from "$common/utils/language";
// 国际化语言配置
// 项目语言包
//  从 navigator 里先获取语言
const navigatorLanguage = window.subLanguage || languageUtils.getPageHeaderCurrentLanguage;
const locale = navigatorLanguage.indexOf('zh') !== -1 ? 'zh' : navigatorLanguage.indexOf('en') !== -1 ? 'en' : 'km';
export default {
  use: (Vue) => {
    Vue.use(VueI18n);
    //  初始化 i18n 对象
    const i18n = new VueI18n({
      locale, // 设置语言环境
      fallbackLocale: window?.subLanguage ?? locale,
      messages: {
        zh: require('./language/zh'),
        en: require('./language/en'),
        km: require('./language/km'),
      },
      silentTranslationWarn: true // 禁止没匹配警告
    });
    return i18n;
  }
};
